
<template>
  <build-your-deal></build-your-deal>
</template>

<script>
import BuildYourDeal from "./index.vue";

export default {
  name: "hot-deals",
  components: {
    "build-your-deal": BuildYourDeal
  }
};
</script>